<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>confirmation.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <p class="vox-paragraph mb-4" [innerHTML]="message | translate: params"></p>
      <div class="buttons-container">
        <button type="button" class="vox-btn vox-btn-secondary-dark-grey" (click)="close()" translate>confirmation.cancel</button>
        <button type="button" class="vox-btn vox-btn-secondary" (click)="ok()" translate>confirmation.ok</button>
      </div>
    </div>
  </div>
</div>
